// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1Ru_5","content":"RecentSearches_content__3fJub"};